var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9,
    r: 9,
    fill: "#B8EF36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46584 5.18191C8.98615 5.18191 8.59157 5.02717 8.28209 4.71769C7.97261 4.40821 7.81787 4.02137 7.81787 3.55715C7.81787 3.09293 7.97261 2.70609 8.28209 2.39661C8.59157 2.07166 8.98615 1.90918 9.46584 1.90918C9.93006 1.90918 10.3169 2.07166 10.6264 2.39661C10.9359 2.70609 11.0906 3.09293 11.0906 3.55715C11.0906 4.02137 10.9359 4.40821 10.6264 4.71769C10.3169 5.02717 9.93006 5.18191 9.46584 5.18191Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0906 14.182V8.45472C11.0906 7.55098 10.358 6.81836 9.45423 6.81836C8.5505 6.81836 7.81787 7.55098 7.81787 8.45472V14.182C7.81787 15.0857 8.5505 15.8184 9.45423 15.8184C10.358 15.8184 11.0906 15.0857 11.0906 14.182Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewInfo);
export default __webpack_public_path__ + "static/media/preview_info.047d880e07e0e5f91ba330e35b113f41.svg";
export { ForwardRef as ReactComponent };